export default {
    title_list: 'Membership cards',
    title_page: 'Membership card',
    title_create_page: 'Create a Membership card',
    title_edit_page: 'Change the Membership card',

    filter: {
        labels: {
            plan_id: 'Membership',
            title: 'Description',
            active: 'Active',
        }
    },

    table: {
        labels: {
            id: 'ID',
            plan_id: 'Membership',
            title: 'Description',
            position: 'Order',
            active: 'Active',
        }
    },

    buttons: {

    },

    form: {
        plan_id: 'Membership',
        title: 'Description',
        note: 'Note',
        position: 'Order',
        active: 'Active',
    },
}
